/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {uniqueId} from 'lodash';
import i18n from '../i18n';

export const Holiday = yup.object({
   name: yup.string().required(i18n.t('Holiday Name must be specified')),
   date: yup.localDate().required(i18n.t('Holiday Date must be specified')),
});
export type IHoliday = yup.InferType<typeof Holiday>;

export const HolidayWithId = Holiday.shape({
   id: yup
      .originString()
      .transform(function (val, origin) {
         if (val && val.length) return val;
         return uniqueId('holiday');
      })
      .defined(),
});
export type IHolidayWithId = yup.InferType<typeof HolidayWithId>;
